module.exports = __webpack_public_path__ + "img/27.97a3845c.svg";